import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useDepositTokenListener = () => {
    const send = useGenericSend();

    return useCallback(async (
        { headers, getParameters, postParameters }: Types.IDepositTokenListenerRequestData
    ): Promise<Types.IDepositTokenListenerResponseData> => {
        const { data } = await send<Types.IDepositTokenListenerRequestData, Types.IDepositTokenListenerResponseData>({
            ID: 35760,
            responses: [35761, 35762],
            description: 'Deposit token listener',
            ...headers && { headers },
            ...getParameters && { getParameters },
            ...postParameters && { postParameters }
        });

        return data;
    }, [send]);
};
